export const AUTH_TOKEN_KEY = 'authorization';
export const SESSION_MSG_KEY = 'auth_session_message';

const LOGIN_PATH = '/serendipity-web/login';

const PUBLIC_AUTH_URL_PATTERNS = [
  '/signin',
  '/signup',
  '/sign-up',
  '/forgot',
  '/register',
  '/otp',
  '/area_landing_page',
  '/user_redirect_view',
];

export function getAuthToken() {
  return localStorage.getItem(AUTH_TOKEN_KEY);
}

export function getAuthHeaders() {
  const token = getAuthToken();
  if (!token) return {};
  return { authorization: `bearer ${token}` };
}

/** Axios config with Authorization header (reads token at call time). */
export function getAuthConfig(extraConfig = {}) {
  const authHeaders = getAuthHeaders();
  const mergedHeaders = {
    ...authHeaders,
    ...(extraConfig.headers || {}),
  };
  return {
    ...extraConfig,
    headers: Object.keys(mergedHeaders).length ? mergedHeaders : extraConfig.headers,
  };
}

export function isPublicAuthRequest(url = '') {
  const lower = String(url).toLowerCase();
  return PUBLIC_AUTH_URL_PATTERNS.some((pattern) => lower.includes(pattern));
}

export function getApiErrorMessage(
  error,
  fallback = 'Something went wrong. Please try again.'
) {
  const status = error?.response?.status;
  const data = error?.response?.data;

  if (status === 401) {
    return 'Session expired. Please sign in again.';
  }
  if (status === 403) {
    return 'Unauthorized access.';
  }

  if (typeof data === 'string') {
    const lower = data.toLowerCase();
    if (lower.includes('autherror') || lower.includes('token not provided')) {
      return 'Session expired. Please sign in again.';
    }
    return data;
  }

  if (data?.ResponseMessage) return data.ResponseMessage;
  if (data?.message) return data.message;

  return fallback;
}

let redirecting = false;

export function clearAuthAndRedirect(
  message = 'Session expired. Please sign in again.',
  { sessionExpired = true } = {}
) {
  if (redirecting) return;
  redirecting = true;

  if (sessionExpired && message) {
    sessionStorage.setItem(SESSION_MSG_KEY, message);
  }

  localStorage.clear();

  if (!window.location.pathname.includes('/login')) {
    window.location.assign(LOGIN_PATH);
  } else {
    redirecting = false;
  }
}
